// The rising word pace's default staircase (Axel approved 6 → 12 on 2026-10-14; docs/COURSE.md
// "Pacing", docs/design/SANAPAJA.md "Rising word pace to Halloween 2027"). One source for
// scripts/src/lib/course-plan.ts DEFAULT_PACE, api/src/frontier.ts defaultPace, app/src/lib/shared.ts
// FALLBACK_PACE; db/seed-users.sql.example and db/migrations/0032_pace_tenth_stair.sql hold the same
// JSON (scripts/test/course-plan.test.ts checks they agree; 0030 holds the first, 7-stair one, 0031 the 8-stair one,
// 0032 the 10-stair one; db/migrations/0035_pace_grammar_hold.sql the current one, with the hold).
import type { PaceStaircase } from './types';

export const DEFAULT_STAIRCASE: Readonly<PaceStaircase> = {
  start: 6,
  step: 1,
  // 7 stairs (6 → 12) were computed by the build from the course's first 3025 words; Axel 2026-10-18: the 8th
  // stair when a Sanapaja wave takes the buffer before the goal under three weeks. Wave 6 did (3266 words: the
  // last ones 17 days before the goal on 7 stairs, 31 days on 8; docs/design/sanapaja/12-wave-6.md), wave 10 did
  // again (wave 9 left exactly three weeks on 8 stairs): the 9th stair, and waves 11–13 again (the loans, the names and the
  // calendar: 3 7xx words, the last ones 10 days before the goal on 9 stairs; docs/design/sanapaja/16-wave-10.md): the 10th.
  steps: 10,
  until: '2027-09-24',
  // FSRS asks for 90 % recall (app/src/lib/fsrs.ts request_retention 0.9): a rise waits when either of
  // you recalls under 85 % of the review-state cards over two weeks. Our own logs were too thin to set
  // it on 2026-10-14 (13 such reviews in all, every one right): an open question for Axel
  // (docs/design/sanapaja/A1-rising-pace.md).
  minRecall: 0.85,
  // Axel 2026-10-25: "new words are too many": the first three months of the course (2026-10-10 … 2027-01-10) are for
  // grammar, at most 2 new words a day in all; the stairs climb 6 → 15 from 2027-01-11 to `until`. The course then covers
  // fewer words by the goal: the build plans only the words this pace releases (scripts/src/lib/course-plan.ts).
  hold: { perDay: 2, until: '2027-01-10' },
};
